import React from "react";

function PrivacyPolicy() {
  return (
    <div className="m-5">
      <p>
        PRIVACY POLICY 2024
        <br />
        <strong>ADVENTURE DATING, LLC.</strong>
      </p>
      <p>
        Welcome to the Adventure Dating Privacy Policy. This explains how we
        collect, store, protect, and share your information, and with whom we
        share it. We suggest you read this in conjunction with our Terms and
        Conditions of Use.
      </p>
      <p>
        While you are enjoying the Adventure Dating mobile application
        (including the desktop version) (“App”), our websites (such as
        adventureDating.com) or using our we collect some information about you.
        We may also need to share your information sometimes.
      </p>
      <p>
        <strong>COLLECTION OF INFORMATION</strong>
      </p>
      <p>Registration Information</p>
      <p>
        When you download the App and create an account (“Account”), we may
        collect certain information (“Registration Information”) about you, such
        as:
      </p>
      <p>- Name;</p>
      <p>- Username;</p>
      <p>- Email address;</p>
      <p>- Cell Phone number;</p>
      <p>- Gender identity;</p>
      <p>- Dates and Times</p>
      <p>- Age;</p>
      <p>- Sexual preference;</p>
      <p>- Photographs;</p>
      <p>- Adventures you are interested in</p>
      <p>- Location; and</p>
      <p>- Login information for your google account</p>
      <p>
        Once you register, you will be able to review and change this
        information at any time just by logging in to Adventure Dating. It is
        your responsibility to ensure that your account details are kept up to
        date. If your phone number changes, please ensure that you update this
        in your account.
      </p>
      <p>
        The information we collect helps to enhance the App and verify our
        Users. Registration Information such as your sexual preference, name and
        username may be visible to other Users who view your profile page.
        <br />
        \fFor Users who are California residents, the data we may collect falls
        within the following categories of “personal information”, as defined by
        the California Consumer Privacy Act (CCPA):
      </p>
      <p>A. Identifiers, such as name and location;</p>
      <p>
        B. Personal information, as defined in the California customer records
        law, such as contact (including email and telephone number) and
        financial information;
      </p>
      <p>
        C. Characteristics of protected classifications under California or
        federal law (if you choose to provide them), such as age, gender
        identity, marital status, sexual orientation, race, ancestry, national
        origin, religion, and medical conditions;
      </p>
      <p>
        D. Commercial information, such as transaction information and purchase
        history;
      </p>
      <p>E. Biometric information;</p>
      <p>
        F. Internet or network activity information, such as browsing history
        and interactions with our Sites and App;
      </p>
      <p>G. Geolocation data, such as mobile device location;</p>
      <p>
        H. Audio, electronic, visual and similar information, such as photos and
        videos;
      </p>
      <p>
        L. Professional or employment-related information, such as work history
        and prior employer;
      </p>
      <p>J. Non-public education information; and</p>
      <p>
        K. Inferences drawn from any of the personal information listed above to
        create a profile or summary about, for example, an individual’s
        preferences and characteristics.
      </p>
      <p>
        <strong>Profile Information</strong>
      </p>
      <p>
        We recommend and encourage you to be responsible about the information
        you disclose about yourself. Please do not use email addresses, URLs,
        instant messaging details, phone numbers, full names or addresses,
        credit card details, national identity numbers, drivers’ license details
        and other sensitive information which is open to abuse and misuse on
        your profile.
      </p>
      <p>
        When you post information about yourself or use the messaging function
        to communicate with other Users, the amount of personal information you
        share is at your own risk. Please see Section 4 below for more
        information on who can access what you post on Adventure Dating.com
      </p>
      <p>
        <strong>
          Profile Verification Information (Including Biometric Information)
        </strong>
      </p>
      <p>
        For safety and security and to ensure you have the best possible user
        experience, we require Usérs to verify their accounts and might ask for
        your phone number and, in some instances, we might also ask that you
        carry out photo cerification. We want to make sure you are not a robot.
        <br />
        And we also want to avoid fake Adventure Dating accounts being created
        which can be used for malicious activities and cybercrime. This
        verification might be required by us for the prevention of fraud.
      </p>
      <p>
        <strong>Purchases Information</strong>
      </p>
      <p>
        If you decide to purchase any of our premium services, we will process
        your payment information and retain this securely for the prevention of
        fraud and for audit/tax purposes
      </p>
      <p>
        <strong>Geolocation Information</strong>
      </p>
      <p>
        If you have given Adventure Dating access to your location in your
        device settings, when you use your cell, we will collect information
        about WiFi access points as well as other location information about
        your longitude and latitude and may save your device’s coordinates to
        offer certain features to you. This information helps us identify your
        physical location and we use it to personalize the App and make it
        easier for you to interact with other Users, by enabling the
        <br />
        general locality information to be displayed to Users seeing your
        profile and showing you the profiles of other Users who are near you.
      </p>
      <p>
        If you have given Adventure Dating access to your location, but wish to
        turn this off, you can do so by the following methods:
      </p>
      <p>
        1. iPhone app — settings, privacy, location services, Adventure Dating
      </p>
      <p>
        2. Android — settings, location, Adventure Dating permissions, location
      </p>
      <p>Device and Photos Information</p>
      <p>
        We may collect information about your device when you use the App
        including the unique device identifier, device model, and operating
        system, for a number of purposes, as set out in this policy.
      </p>
      <p>Messages</p>
      <p>
        We review the content of messages sent in the App to identify topics,
        sentiments, and trends across our Users. We will take steps to remove
        personally identifying information from such messages, prior to
        reviewing them. We will not share the content of User messages or
        information we derive from them with any third party.
      </p>
      <p>
        If you contact our Customer Support tea we will receive your email
        address, and may track your IP address, as well as the information you
        send to us to help resolve your issue.
      </p>
      <p>\fCookies and similar technologies</p>
      <p>
        When you visit our Sites or when you use our App, we may collect
        personal data from you automatically by using cookies or similar
        technologies. A cookie is a small file that can be placed on your device
        or browser that allows us to recognize and remember you.
      </p>
      <p>
        If you would like to find out more about cookies, including how we use
        them and what choices are available to you, please refer to our Cookie
        Policy.
      </p>
      <p>
        <strong>USE OF YOUR INFORMATION</strong>
      </p>
      <p>
        Our main goal is to ensure your experience on Adventure Dating is an
        amazing adventure with 2 like-minded individual. We may use your
        Registration and other information to:
      </p>
      <p>- offer you our services and features</p>
      <p>
        - contact you with information about the App (e.g. updates and new
        features)
      </p>
      <p>- personalize the App/Sites and the content we deliver te you</p>
      <p>
        - to test new technologies and processes designed to enhance and improve
        the App/Sites
      </p>
      <p>
        - resolve disputes, troubleshoot problems and to enforce our Terms &amp;
        Conditions
      </p>
      <p>
        - investigate fraud_ protect our legal rights. and to enforce our Terms
        &amp; Condition
      </p>
      <p>DISCLOSURES</p>
      <p>Service Providers</p>
      <p>
        We engage certain trusted third parties to perform functions and provide
        services to us (“Service Providers”). The suppliers with which Adventure
        dating shares User personal data vary depending on a variety of factors.
        such as which of our App, Sites and services a User engages with. For
        example, to provide our services to Users, we typically use the
        following suppliers:
      </p>
      <p>
        Billing services — to allow customers to purchase paid features of our
        App
      </p>
      <p>Authentication services</p>
      <p>Social media</p>
      <p>
        <strong>
          IT services — some of the third-party software providers used in the
          Operation of our business may process Users” personal data
        </strong>
      </p>
      <p>
        \fWe carry out due diligence on all Service Providers we engage to
        ensure they have adequate data protection and information security
        measures in place and only provide them with the personal data necessary
        to the service they are providing. Measures are taken to ensure that the
        data shared is non-attributable to the greatest extent possible and our
        suppliers are also subject to extensive obligations under our
        contractual arrangements, including strict data retention limits.
      </p>
      <p>
        <strong>WHAT OTHERS MAY SEE ABOUT YOU</strong>
      </p>
      <p>
        Our App is designed to make it easier for you to connect with other
        Users and to interact with them. When using the Adventure Dating App,
        you should assume that everything you post or submit on the App may be
        publicly- viewable and accessible, both by Users and non-users of the
        App. We want our Users to be careful about posting information that may
        eventually be made public.
      </p>
      <p>
        <strong>OUR POLICY TOWARDS AGE</strong>
      </p>
      <p>
        Although we want as many people as possible to enjoy our creation, you
        have to be at least 18 years old to use Adventure Dating.
      </p>
      <p>
        Adventure Dating does not knowingly collect any information about or
        market to children, minors or anyone under the age of 18. If we become
        aware that a child, minor or anyone under the age of 18 has registered
        with us and provided us with personal information, we will take steps to
        terminate that person’s registration.
      </p>
      <p>
        <strong>SECURITY</strong>
      </p>
      <p>
        At Adventure Dating, we will take all appropriate security measures to
        help protect your information against loss, misuse and unauthorized
        access, or disclosure. We use reasonable security measures to
        safeguard\fthe confidentiality of your personal information such as
        secured servers using firewalls, Unfortunately, no website or Internet
        transmission is ever completely 100% secure and even we cannot guarantee
        that unauthorized access, hacking, data loss or other breaches will
        never occur, but here are some handy tips to help keep your data secure:
      </p>
      <p>1. Please make sure you log out of your Account after use.</p>
      <p>
        2. Please don’t share the password you use to access your Adventure
        Dating Account
      </p>
      <p>
        <strong>LINKING OTHER ACCOUNTS</strong>
      </p>
      <p>Using your social media details to sign in to Adventure Dating</p>
      <p>
        If you register or sign in with your Google ID, you give Google
        permission to share your Google login, a name and an email email
        address. This email address will be linked to your Adventure Dating
        account.
      </p>
      <p>
        <strong>YOUR CALIFORNIA PRIVACY RIGHTS</strong>
      </p>
      <p>
        For Users who are California residents, you have the following rights
        (in addition to those listed at section 10 below) under the California
        Consumer Privacy Act, and you have the right to be free from unlawful
        <br />
        discrimination for exercising your rights under the Act:
      </p>
      <p>
        1. You have the right to request that we disclose certain information to
        you and explain how we have collected, used and shared your personal
        information over the past 12 months,
      </p>
      <p>
        2. You have the right to request that we delete your personal
        information that we collected from you, subject to certain exceptions.
      </p>
      <p>
        California’s “Shine the Light” law, Civil Code section 1798.83, requires
        certain businesses to respond to requests from California customers
        asking about the businesses’ practices related to disclosing personal
        information to third parties for the third parties’ direct marketing
        purposes, If you wish to find out about any rights you may have under
        California Civil Code section 1798.83, you can write to us at
        admin@adventuredating.com
      </p>
      <p>
        In addition, under California law, operators of online services are
        required to disclose how they respond to “do not track” signals or other
        similar mechanisms that provide consumers the ability to exercise choice
        regarding the collection of personal information of a consumer over time
        and across third party online services, to the extent the operator
        engages in that collection. At this time, we do not track our Users’
        personal information over time and across third-party online services.
        This law also requires operators of online services to disclose whether
        third parties may collect personal information about their users’ online
        activities over time and across different online services when the users
        use the operator’s service. We do not knowingly permit third parties to
        collect personal information about an individual User’s online
        activities over time and across different online services when using the
        App.
      </p>
      <p>
        <strong>YOUR RIGHTS</strong>
      </p>
      <p>
        Privacy laws applicable in the United States may give you the following
        rights:
      </p>
      <p>
        1. Right to be informed: what personal data an organization is
        processing and why (we provide this information to you in this Privacy
        Policy).
      </p>
      <p>2. Right of access: you can request a copy of your data.</p>
      <p>
        3. Right of rectification: if the data held is inaccurate, you have the
        right to have it corrected.
      </p>
      <p>
        4. Right to erasure: you have the right to have your data deleted in
        certain circumstances.
      </p>
      <p>
        5. Right to restrict processing: in limited circumstances, you have the
        right to request that processing is stopped but the data retained.
      </p>
      <p>
        6. Right to data portability: you can request a copy of certain data in
        a machine-readable form that can be transferred to another provider.
      </p>
      <p>
        7. Right to object: in certain circumstances (including where data is
        processed on the basis of legitimate interests or for the purposes of
        marketing) you may object to that processing.
      </p>
      <p>
        8. Rights related to automated decision-making including profiling:
        there are several rights in this area where processing carried out on a
        solely automated basis results in a decision which has legal or
        <br />
        significant effects for the individual.
        <br />
        &nbsp;
      </p>
      <section>
        <strong>SUBSCRIPTION INFORMATION</strong>

        <p>
          <strong>Adventure Dating</strong> offers two types of
          <strong> auto-renewable subscription plans</strong> that unlock
          premium features and enhance user experience.
        </p>

        <strong>Premium Plan</strong>
        <ul>
          <li>
            <strong>Price:</strong> $19.99/month (Pricing may vary by region)
          </li>
          <li>
            <strong>Renewal:</strong> Auto-renewable, billed monthly
          </li>
          <li>Chat with your matches</li>
          <li>Access profile editing features</li>
          <li>Discover more users by expanding search range</li>
        </ul>

        <strong>Premium Plus Plan</strong>
        <ul>
          <li>
            <strong>Price:</strong> $29.99/month (Pricing may vary by region)
          </li>
          <li>
            <strong>Renewal:</strong> Auto-renewable, billed monthly
          </li>
          <li>Includes all Premium features</li>
          <li>Access to Concierge Date Request service</li>
          <li>Admin-approved real-world adventure date coordination</li>
          <li>Priority visibility in search results</li>
        </ul>

        <strong>Subscription Terms and Cancellation</strong>
        <ul>
          <li>
            Payment is charged to your Apple ID account upon purchase
            confirmation.
          </li>
          <li>
            Subscriptions auto-renew unless canceled at least 24 hours before
            the end of the current billing cycle.
          </li>
          <li>
            Your account will be charged for renewal within 24 hours prior to
            the end of the current period.
          </li>
          <li>
            You can manage or cancel your subscription anytime from your App
            Store account settings.
          </li>
          <li>
            Cancellation stops auto-renewal but retains access until the end of
            the billing period.
          </li>
          <li>
            No refunds are issued for unused portions of the subscription.
          </li>
          <li>Subscriptions are valid only within the Adventure Dating app.</li>
        </ul>
      </section>
    </div>
  );
}

export default PrivacyPolicy;
